import { useEffect } from "react";
import { Helmet } from "react-helmet";

import "../pages/Gallery.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function Gallery() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Project Gallery | Solar & Environmental Projects | RAD EnviroNex</title>
        <meta name="description" content="View our completed solar panel installations, sewage treatment plants, and environmental audit projects across Tamil Nadu. Quality projects by RAD EnviroNex." />
        <meta name="keywords" content="Solar Project Gallery Madurai, STP Project Photos, ETP Installation Videos, RAD EnviroNex Portfolio, Environmental project gallery" />
        <link rel="canonical" href="https://radenvironex.com/Gallery" />
      </Helmet>
      <Navbar />


      {/* GALLERY WRAPPER */}
      <section className="gallery-page">

        {/* IMAGE GALLERY */}
        <div className="gallery-section">
          <h2 className="gallery-title">Image Gallery</h2>

          <div className="gallery-grid">
            <img
              src="https://images.unsplash.com/photo-1509391366360-2e959784a276"
              alt="Solar Panels"
              loading="lazy"
            />
            <img
              src="https://images.unsplash.com/photo-1581092160607-ee22621dd758"
              alt="Solar Installation"
              loading="lazy"
            />
            <img
              src="https://images.unsplash.com/photo-1584277261846-c6a1672ed979"
              alt="Solar Power Plant"
              loading="lazy"
            />
            <img
              src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d"
              alt="Renewable Energy Industry"
              loading="lazy"
            />
          </div>
        </div>

        {/* GAP */}
        <div className="gallery-gap"></div>

        {/* VIDEO GALLERY */}
        <div className="gallery-section">
          <h2 className="gallery-title">Video Gallery</h2>

          <div className="gallery-grid">
            <video
              src="https://cdn.pixabay.com/video/2019/10/22/28245-367270991_large.mp4"
              controls
              muted
              preload="metadata"
            />
            <video
              src="https://cdn.pixabay.com/video/2020/03/16/33467-402084785_large.mp4"
              controls
              muted
              preload="metadata"
            />
            <video
              src="https://cdn.pixabay.com/video/2021/08/20/85911-594289438_large.mp4"
              controls
              muted
              preload="metadata"
            />
            <video
              src="https://cdn.pixabay.com/video/2020/09/21/50208-460917468_large.mp4"
              controls
              muted
              preload="metadata"
            />
          </div>
        </div>

      </section>

      <Footer />
    </>
  );
}